<template>
  <div>
    <PagesPath :pathTitle1="'درباره ما'" :pathTo1="'about-us'"></PagesPath>
    <div class="content-about box-shaddow20">
      <div class="image-about p-0 border-r-20 container mt-4 mb-3">
        <figure class="border-r-20">
          <img
            class="w-100 d-lg-none border-r-20"
            src="@/assets/images/about-us.jpg"
            alt="image-about"
          />
          <img
            class="w-100 d-none d-lg-block border-r-20"
            src="@/assets/images/فروشگاه copy1.jpg"
            alt="image-about"
          />
        </figure>
      </div>
      <section class="p-3 border-r-20 container mt-4 mb-5">
        <div
          class="d-flex flex-column flex-lg-row justify-content-lg-between align-items-lg-baseline gap-lg-40"
        >
          <h5 class="text-color-444 my-lg-4 font-weight-bold">
            <span class="font-weight-bold"
              >🌿 داستان بندیتو؛ مسیر یک مراقبت طبیعی</span
            >
          </h5>
          <span class="line-about d-none d-lg-block mx-3"></span>
        </div>
        <p class="line-height2 text-color-666 fontsize16 text-justify">
          بندیتو از یک باور ساده آغاز شد: این‌که مراقبت از خود، قبل از آن‌که
          محصول باشد، یک نگرش است. نگرشی مبتنی بر احترام به بدن، اعتماد به طبیعت
          و انتخاب آگاهانه.
        </p>
        <p class="line-height2 text-color-666 fontsize16 text-justify">
          از دل طبیعت گلستان در سال ۱۳۹۴، بندیتو در استان گلستان متولد شد؛
          سرزمینی با طبیعت بکر ، دشت های وسیع و سرشار از گیاهان دارویی، دانه‌های
          روغنی و درختان ارزشمند زیتون. جغرافیایی که قرن‌ها، منبع مراقبت طبیعی
          برای انسان بوده است. گلستان بهشتی برای گیاهان دارویی است. ما با الهام
          از گیاهانی مانند رزماری، بابونه، گزنه، آویشن، اسطوخودوس و دیگر گیاهان
          این منطقه، مسیر تولید محصولاتی را آغاز کردیم که ریشه در دانش سنتی و
          نگاهی علمی به نیازهای امروز دارند.
        </p>
      </section>
      <section class="Trusted-customers">
        <TrustedCustomers />
      </section>
      <section class="p-3 border-r-20 container mt-4 mb-5">
        <div
          class="d-flex flex-column flex-lg-row justify-content-lg-between align-items-lg-baseline gap-lg-40"
        >
          <h5 class="text-color-444 my-lg-4 font-weight-bold">
            <span class="font-weight-bold"
              >از روغن‌های ساده تا فرمول‌های هوشمند</span
            >
          </h5>
          <span class="line-about d-none d-lg-block mx-3"></span>
        </div>
        <p class="line-height2 text-color-666 fontsize16 text-justify">
          بندیتو کار خود را با روغن‌های گیاهی ساده آغاز کرد؛
        </p>
        <p class="line-height2 text-color-666 fontsize16 text-justify">
          اما به‌مرور دریافتیم که مراقبت مؤثر، نیازمند شناخت دقیق‌تر و ترکیب‌های
          هوشمندانه‌تر است. به همین دلیل، تمرکز ما بر تولید روغن‌های ترکیبی
          گیاهی قرار گرفت؛ محصولاتی با فرمولاسیون اختصاصی که هرکدام برای پاسخ به
          یک نیاز واقعی طراحی شده‌اند، با احترام به تعادل طبیعی پوست و مو.
        </p>
      </section>
      <section>
        <CollaborateWith />
      </section>
      <section>
        <infoDownAbout></infoDownAbout>
      </section>
      <!-- <section class="p-3 border-r-20 container mt-4 mb-5">
        <div
          class="d-flex flex-column flex-lg-row justify-content-lg-between align-items-lg-baseline gap-lg-40"
        >
          <h5 class="text-color-444 my-lg-4 font-weight-bold fontsize-16">
            <span class="font-weight-bold">بندیتو امروز</span>
          </h5>
          <span class="line-about d-none d-lg-block mx-3"></span>
          <p class="text-color-999">
            بعد از سال‌ها تلاش، امروز بندیتو نه‌تنها به یک برند شناخته‌شده در
            حوزه روغن‌های گیاهی و طبیعی تبدیل شده، بلکه هزاران نفر از مشتریان
            وفادار، با اطمینان کامل از محصولات ما استفاده می‌کنند. توسعه
            فرمولاسیون‌های اختصاصی، شفافیت در فرآیند تولید، ارتباط نزدیک با
            مشتریان و ترویج سبک زندگی سالم، بخشی از مسیر امروز بندیتو است. ما
            باور داریم که زیبایی واقعی از درون می‌آید، از مواد خالصی که به بدن
            خود می‌رسانیم و از طبیعتی که در زندگی روزمره‌مان جریان دارد. مسیری
            که بر پایه اعتماد، آموزش و تعهد به کیفیت واقعی شکل گرفته است. نام
            Benedito (Benedetto) به معنای حس خوب ، مبارک و خوش‌یمن است؛ نامی که
            فلسفه‌ی ما را در خود دارد.
          </p>
        </div>
        <p class="line-height2 text-color-666 fontsize16 text-justify">
          بندیتو؛
        </p>
        <p class="line-height2 text-color-666 fontsize16 text-justify">
          وجودت لبخندی زیباست.
        </p>
      </section> -->
    </div>
    <Footer></Footer>
  </div>
</template>

<script>
import PagesPath from "@/parts/Front/components/PagesPath";
import TrustedCustomers from "@/parts/Front/components/about-us/Trusted-customers";
import CollaborateWith from "@/parts/Front/components/about-us/Collaborate-with";
import infoDownAbout from "@/parts/Front/components/about-us/info-down-about";
export default {
  name: "AboutUs",
  components: {
    PagesPath,
    TrustedCustomers,
    CollaborateWith,
    infoDownAbout,
  },
  data() {
    return {
      options: [
        {
          title: "تضمین اصالت",
        },
        {
          title: "قیمت مناسب",
        },
        {
          title: "کیفیت خوب",
        },
      ],
    };
  },
  mounted() {
    // let aboutUsImg=document.querySelectorAll('.about-us-why-img')[0];
    // aboutUsImg.style.height = (aboutUsImg.offsetWidth * 1.2) + "px";
    // window.addEventListener('resize' , function() {
    //   let aboutUsImg=document.querySelectorAll('.about-us-why-img')[0];
    //   aboutUsImg.style.height = (aboutUsImg.offsetWidth * 1.2) + "px";
    // });
  },
};
</script>

<style scoped>
.line-about {
  height: 1px;
  background-color: #e7e7e7;
  flex-grow: 1;
}
.image-about {
  position: relative;
  top: -200px;
  margin: 0 auto !important;
  margin-bottom: -170px !important;
}
.content-about {
  margin-top: 230px;
}
.image-about img {
  object-fit: cover;
}
@media screen and (max-width: 998px) {
  .image-about {
    position: relative;
    top: -95px;
    margin-bottom: -80px !important;
  }
  .content-about {
    margin-top: 125px;
  }
}
@media screen and (max-width: 768px) {
  .image-about {
    padding: 0 30px !important;
    height: 210px;
  }
  .image-about img {
    object-fit: cover;
    height: 210px;
  }
}
</style>
